import { createIntl, createIntlCache } from 'react-intl';
import French from '../../../lang/fr.json';
import English from '../../../lang/en.json';
import { COUNTRY } from '../../environment';

const cache = createIntlCache();

let locale = 'en';

if (typeof window !== 'undefined') {
  const storedLocale = localStorage.getItem('locale');
  if (storedLocale) {
    locale = storedLocale;
  }
}

const messages = locale === 'en' ? English : French;

// Always defined singleton
export const intl = createIntl({ locale, messages }, cache);
export const { formatMessage } = intl;

export const INTRODUCTION = -1;
export const PERSONAL_DETAILS = 0;
export const LOCATION_DETAILS = 1;
export const TERMS_OF_USE = 2;
export const PROFESSIONAL_DETAILS = 3;
export const PRACTICE_DETAILS = 4;
export const MATCHING_PREFERENCES = 5;
export const TAX_INFORMATION = 6;
export const THANK_YOU = COUNTRY === 'CA' ? 7 : 6;

export const steppers = buildSteppers();

function buildSteppers() {
  /* eslint-disable no-shadow */
  const steppers = [
    {
      label: formatMessage({ defaultMessage: 'Personal Details' }),
      value: PERSONAL_DETAILS,
    },
    {
      label: formatMessage({ defaultMessage: 'Location Details' }),
      value: LOCATION_DETAILS,
    },
    {
      label: formatMessage({ defaultMessage: 'Terms of Use' }),
      value: TERMS_OF_USE,
    },
    {
      label: formatMessage({ defaultMessage: 'Professional Details' }),
      value: PROFESSIONAL_DETAILS,
    },
    {
      label: formatMessage({ defaultMessage: 'Practice Details' }),
      value: PRACTICE_DETAILS,
    },
    {
      label: formatMessage({ defaultMessage: 'Matching Preferences' }),
      value: MATCHING_PREFERENCES,
    },
  ];

  if (COUNTRY === 'CA') {
    steppers.push({
      label: formatMessage({ defaultMessage: 'Tax Information' }),
      value: TAX_INFORMATION,
    });
  }

  return steppers;
}

export const titles = [
  {
    value: 'Dr',
    label: formatMessage({ defaultMessage: 'Dr' }),
  },
  {
    value: 'Mr',
    label: formatMessage({ defaultMessage: 'Mr' }),
  },
  {
    value: 'Ms',
    label: formatMessage({ defaultMessage: 'Ms' }),
  },
  {
    value: 'Miss',
    label: formatMessage({ defaultMessage: 'Miss' }),
  },
  {
    value: 'Mx',
    label: formatMessage({ defaultMessage: 'Mx' }),
  },
];

export const yesNo = [
  {
    value: 'true',
    label: formatMessage({ defaultMessage: 'Yes' }),
  },
  {
    value: 'false',
    label: formatMessage({ defaultMessage: 'No' }),
  },
];

export const bachelorDegrees = [
  { value: 'BA', label: formatMessage({ defaultMessage: 'Arts' }) },
  { value: 'BSc', label: formatMessage({ defaultMessage: 'Science' }) },
  { value: 'BSW', label: formatMessage({ defaultMessage: 'Social Work' }) },
  { value: 'BEd', label: formatMessage({ defaultMessage: 'Education' }) },
];

export const mastersDegrees = [
  { value: 'MC', label: formatMessage({ defaultMessage: 'Counselling' }) },
  { value: 'MSW', label: formatMessage({ defaultMessage: 'Social Work' }) },
  {
    value: 'MScPsych',
    label: formatMessage({ defaultMessage: 'Psychology' }),
  },
  { value: 'MEd', label: formatMessage({ defaultMessage: 'Education' }) },
  { value: 'MDv', label: formatMessage({ defaultMessage: 'Divinity' }) },
  {
    value: 'MOT',
    label: formatMessage({ defaultMessage: 'Occupational Therapy' }),
  },
];

export const phds = [
  {
    value: 'PhDPsych',
    label: formatMessage({ defaultMessage: 'Psychology' }),
  },
];

export const medical = [
  {
    value: 'GP',
    label: formatMessage({ defaultMessage: 'General Practitioner' }),
  },
  { value: 'Psych', label: formatMessage({ defaultMessage: 'Psychiatrist' }) },
  {
    value: 'RN/RPN',
    label: formatMessage({ defaultMessage: 'Registered Nurse' }),
  },
];

export const diplomas = [
  { value: 'DC', label: formatMessage({ defaultMessage: 'Counselling' }) },
  {
    value: 'ICAF',
    label: formatMessage({
      defaultMessage: 'International Coach Federation Accredited',
    }),
  },
];

export const modalities = [
  { value: 'voice', label: formatMessage({ defaultMessage: 'Voice' }) },
  { value: 'video', label: formatMessage({ defaultMessage: 'Video' }) },
  {
    value: 'in_person',
    label: formatMessage({ defaultMessage: 'In-Person' }),
  },
];

export const normalizeStripeError = stripeError => {
  const localizeStripeError = error => {
    if (error?.param === 'file') {
      return formatMessage({
        defaultMessage:
          "The file type you sent us isn't being recognized. Please try another file.",
      });
    }

    if (error?.code === 'routing_number_invalid') {
      return formatMessage({
        defaultMessage:
          "We couldn't find the bank for that transit/institution number.",
      });
    }

    return formatMessage({
      defaultMessage: 'Something went wrong. Please try again.',
    });
  };

  return localizeStripeError(stripeError);
};

export const toMultiSelectOptions = options =>
  options.map(option => ({
    id: option.id,
    name: option.name,
    label: option.name,
    value: option.id,
  }));
